import { useTranslation } from 'react-i18next'
import type { LocaleAvailability } from '@/domains/types'
import { Badge } from '@/ui/components/common/Badge'

/** One locale's completeness badge — complete/stale/missing, or a dash when
 * there is no data at all for that locale. Extracted verbatim from the
 * dashboard's `DashboardCell` so the drill-down tables render identical
 * badges. */
export function TranslationStatusBadge({ state }: { state: LocaleAvailability | undefined }) {
  const { t } = useTranslation()

  if (!state) {
    return <span className="text-xs text-muted-foreground">—</span>
  }

  if (state.complete && state.staleFields === 0) {
    return (
      <Badge variant="outline" className="text-emerald-600 border-emerald-400">
        {t('translations.badge_complete')}
      </Badge>
    )
  }

  if (state.complete && state.staleFields > 0) {
    return (
      <Badge variant="outline" className="text-amber-600 border-amber-400">
        {t('translations.badge_stale')}
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className="text-muted-foreground">
      {t('translations.badge_missing', { count: state.missingFields })}
    </Badge>
  )
}
